import { useEffect } from 'react';

// Single-flag module-level registry so the Sign Out button in the page
// header can check whether the assessment form (a sibling subtree) has
// uncommitted work without lifting state via context.
let dirty = false;

export const hasUnsavedChanges = () => dirty;

const setDirty = (next: boolean) => { dirty = next; };

/**
 * Registers the form's dirty state and installs a beforeunload guard
 * for tab close / hard refresh while dirty. SPA navigation (e.g. the
 * Sign Out button) doesn't trigger beforeunload, so the page header
 * must additionally call `hasUnsavedChanges()` before navigating away.
 */
export const useUnsavedChangesGuard = (isDirty: boolean) => {
  useEffect(() => {
    setDirty(isDirty);

    if (!isDirty) return;

    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);

    return () => {
      window.removeEventListener('beforeunload', handler);
      setDirty(false);
    };
  }, [isDirty]);
};
